<template>
  <div>
    <v-card dark style="border-radius:10px;">
      <v-layout row justify-space-between class="pa-3">
        <!-- <v-flex xs1 class="pr-4">
          <v-layout column>
            <v-flex>
              <div
                class="pt-2 text-xs-center"
                @click="$router.push({path : '/weserve_admin_login/control/' + $store.state.backOffice.province + '/report/store_payment' })"
              >
                <v-icon color="white" class="mt-2">arrow_back</v-icon>
              </div>
            </v-flex>
            <v-flex></v-flex>
          </v-layout>
        </v-flex>-->

        <v-flex xs3 class="pl-2">
          <v-layout column>
            <v-flex>Start :</v-flex>
            <v-flex>
              <v-menu
                :close-on-content-click="false"
                v-model="menu1"
                :nudge-right="-30"
                lazy
                transition="scale-transition"
                offset-y
              >
                <v-text-field
                  slot="activator"
                  v-model="search_data.datetime_start"
                  label="Select order start time"
                  prepend-icon="event"
                  hide-details
                  readonly
                ></v-text-field>
                <v-date-picker
                  :min="moment().format('YYYY-MM-DD')"
                  color="#333"
                  no-title
                  v-model="search_data.datetime_start"
                  @input="menu1 = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs3 class="pl-2">
          <v-layout column>
            <v-flex>End :</v-flex>
            <v-flex>
              <v-menu
                :close-on-content-click="false"
                v-model="menu2"
                :nudge-right="-30"
                lazy
                transition="scale-transition"
                offset-y
              >
                <v-text-field
                  slot="activator"
                  v-model="search_data.datetime_end"
                  label="Select order end time"
                  prepend-icon="event"
                  hide-details
                  readonly
                ></v-text-field>
                <v-date-picker
                  :min="moment().format('YYYY-MM-DD')"
                  color="#333"
                  no-title
                  v-model="search_data.datetime_end"
                  @input="menu2 = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs3></v-flex>
        <v-flex xs1>
          <div class="pt-2 text-xs-center search-btn">
            <v-icon large color="black">search</v-icon>
          </div>
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      search_data: {
        search_store_id: 0,
        order_status: 6,
        datetime_start: null,
        datetime_end: null
      },
      store_list: [],
      order_status: [
        { name: "Complete", value: 6 },
        { name: "Cancel", value: 7 }
      ],
      menu1: false,
      menu2: false,
      date: new Date().toISOString().substr(0, 10),
      is_loading_store: false
    };
  },
  computed: {},
  methods: {
    searchStorePayment() {}
  },
  async created() {
    this.store_list = [];
    this.store_list.push({ store_id: 0, store_name_th: "All" });
    this.is_loading_store = true;
    let fetch_store_list = await this.$store.dispatch(
      "fetchStoreBack/getStoreList"
    );
    for (let val of fetch_store_list) {
      this.store_list.push(val);
    }
    this.is_loading_store = false;
  }
};
</script>

<style scoped>
.v-text-field {
  padding-top: 0;
  margin-top: 0;
}
.search-btn {
  cursor: pointer;
  height: 50px;
  width: 50px;
  background-color: #ffd300;
  border-radius: 10px;
}
</style>
